import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/sensor';

const options = {
  cache: {
      maxAge: 30 * 60 * 1000,
      exclude: { query: false }
  }
}

const loadAllSensors = async () => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(END_POINT, options);
}

const loadSensorsByIds = async ({organization_ids, sensor_ids, stationtype_ids}) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, {organization_ids, sensor_ids, stationtype_ids});
  return api.get(url, options);
}

export {
  loadAllSensors,
  loadSensorsByIds
}
